import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Checkbox } from './ui/checkbox';
import { toast } from 'sonner';
import { Package } from 'lucide-react';
import { axiosInstance } from '../App';
import { useBox } from './BoxContext';

const toLabel = (p, i) => ({
  id: Date.now() + i,
  name: p.name || '',
  code: p.code || p.upc || '',
  price: p.price != null ? String(p.price) : '',
  description: p.description || '',
  size: p.talla || '',
  color: p.color || '',
  quantity: 1,
});

export const InventoryLabelPicker = ({ open, onOpenChange, onAdd }) => {
  const { selectedBox } = useBox() || {};
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const [picked, setPicked] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !selectedBox?.id) return;
    setLoading(true);
    setPicked({});
    axiosInstance.get(`/inventory/products?box_id=${selectedBox.id}`)
      .then(r => setItems(r.data.products || []))
      .catch(() => toast.error('No se pudo cargar el inventario'))
      .finally(() => setLoading(false));
  }, [open, selectedBox?.id]);

  const term = q.trim().toLowerCase();
  const filtered = items.filter(p => !term || [p.name, p.code, p.upc, p.talla, p.color].some(v => String(v || '').toLowerCase().includes(term))).slice(0, 200);
  const count = Object.values(picked).filter(Boolean).length;

  const add = () => {
    const sel = items.filter(p => picked[p.id]).map(toLabel);
    onAdd(sel);
    toast.success(`${sel.length} productos agregados desde Inventario`);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="inventory-picker-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Package className="w-5 h-5" /> Agregar desde Inventario</DialogTitle>
        </DialogHeader>
        {!selectedBox?.id ? (
          <p className="text-sm text-gray-500">Selecciona una caja primero.</p>
        ) : (
          <div className="space-y-3">
            <Input placeholder="Buscar por nombre, código, talla o color" value={q} onChange={e => setQ(e.target.value)} data-testid="inventory-picker-search" />
            <div className="max-h-80 overflow-y-auto border rounded divide-y">
              {loading && <p className="p-3 text-sm text-gray-500">Cargando...</p>}
              {!loading && filtered.length === 0 && <p className="p-3 text-sm text-gray-500">Sin productos</p>}
              {filtered.map(p => (
                <label key={p.id} className="flex items-center gap-3 p-2 hover:bg-gray-50 cursor-pointer" data-testid={`inventory-picker-item-${p.id}`}>
                  <Checkbox checked={!!picked[p.id]} onCheckedChange={v => setPicked(s => ({ ...s, [p.id]: v }))} />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate">{p.name}</p>
                    <p className="text-xs text-gray-500">{p.code} · ₡{p.price}{p.talla ? ` · T: ${p.talla}` : ''}{p.color ? ` · ${p.color}` : ''}</p>
                  </div>
                </label>
              ))}
            </div>
          </div>
        )}
        <DialogFooter>
          <Button onClick={add} disabled={!count} data-testid="inventory-picker-add-btn">Agregar {count || ''} a etiquetas</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
